import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
//FB-6264
import { Grid, makeStyles } from "@material-ui/core";
import { GetPatientName } from "../appointments/create/api/index"; // FB 4653 BR:Start - PE - Text message changed in review emails


// update log
// FB 4371 BR    03/29/2021    Thank you UI after submitting the appointment reviews
// FB 4653 BR    08/23/2021    PE - Text message changed in review emails
// FB 4867 DK    12/27/2021    Added screens for Support files and Health forms upload
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR

const Thankyou = (props: any) => {
  // alert(props.match.params.id);
  const [ratingValue, setRatingValue] = useState<number | null>(0);
  const [displayMessage, setDisplayMessage] = useState("none");
  const [displaylink, setDisplaylink] = useState("none");
  const [displayTextarea, setdisplayTextarea] = useState("none");
  const [displaySend, setDisoplaysend] = useState("none");
  const [displaySubmit, setDisoplaysubmit] = useState("flex");
  const [message, setMessage] = useState("");
  const [googlelink, setGoogleLink] = useState("");
  const [freezeStars, setfreezeStars] = useState(false);
  const [comments, setComments] = useState("");
  const [firstName, setFirstName] = useState(""); // FB 4653 BR - PE - Text message changed in review emails

  {/* FB 4653 BR:Start - PE - Text message changed in review emails */ }
  useEffect(() => {
    onload();
  }, []);   //FB 4867

  const onload = async () => {
    const data = await GetPatientName(props.match.params.id);
    setFirstName(data);
  }
  {/* FB 4653 BR:End - PE - Text message changed in review emails */ }

  const useStyles = makeStyles({
    active: {
      backgroundColor: "#18a2b8",
      color: "white",
      textTransform: "capitalize",
      borderRadius: "15px",
      marginLeft: "20px",
      "&:hover": {
        backgroundColor: "#18a2b8",
      },
    },
  });

  const classes = useStyles();

  return (
    <div>
      <Grid
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* <Box component="fieldset" mb={12} style={{display: "flex", alignItems: "center",justifyContent:"center"}} borderColor="transparent"> */}
        <Typography variant="h6" component="legend">
          {/* FB 4653 BR - PE - Text message changed in review emails */}
          We appreciate your kind feedback , {firstName} . Thank you for rating us.
        </Typography>
        {/* </Box> */}
      </Grid>
    </div>
  );
};

export default Thankyou;
